import React, { useEffect, useState } from "react";
import { Input, Tag, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./editableTagGroup.css";
import PropTypes from "prop-types";

const EditableTagGroup = ({ tags = [], tagsInputConfirm, title = "", validation }) => {
  const [state, setState] = useState({
    inputVisible: false,
    inputValue: "",
    editInputIndex: -1,
    editInputValue: "",
    invalidFieldError: {
      showError: false,
      messageError: "",
    },
  });
  let newInput = null;
  let editInput = null;

  useEffect(() => {
    if (state.inputVisible) {
      newInput.focus();
    }
    if (state.editInputValue !== "" && state.editInputIndex !== -1) {
      editInput.focus();
    }
  }, [state.inputVisible, state.editInputIndex, state.editInputValue]);

  const showInput = () => {
    setState((prevState) => ({ ...prevState, inputVisible: true }));
  };

  const handleInputConfirm = () => {
    const { inputValue } = state;
    let newTags = [...tags];
    if (inputValue && tags.indexOf(inputValue) === -1) {
      /**
       * Show error when input entered doesn't pass validation test
       * */
      if (validation && validation(inputValue)) {
        setState((prevState) => ({
          ...prevState,
          invalidFieldError: {
            showError: true,
            messageError: validation(inputValue),
          },
        }));
      } else {
        newTags = [...tags, inputValue];
        setState((prevState) => ({
          ...prevState,
          invalidFieldError: {
            showError: false,
            messageError: "",
          },
        }));
      }
    }
    setState((prevState) => ({ ...prevState, inputValue: "" }));
    setState((prevState) => ({ ...prevState, inputVisible: false }));
    tagsInputConfirm(newTags);
  };

  const handleInputChange = (e) => {
    setState((prevState) => ({ ...prevState, inputValue: e.target.value }));
  };

  const handleEditInputConfirm = () => {
    const { editInputIndex, editInputValue } = state;
    const newTags = [...tags];
    if (validation && validation(editInputValue)) {
      setState((prevState) => ({
        ...prevState,
        invalidFieldError: {
          showError: true,
          messageError: validation(editInputValue),
        },
      }));
    } else {
      newTags[editInputIndex] = editInputValue;
      setState((prevState) => ({
        ...prevState,
        invalidFieldError: {
          showError: false,
          messageError: "",
        },
      }));
    }
    setState((prevState) => ({ ...prevState, editInputValue: "", editInputIndex: -1 }));
    tagsInputConfirm(newTags);
  };

  const handleEditInputChange = (e) => {
    setState((prevState) => ({ ...prevState, editInputValue: e.target.value }));
  };

  const saveEditInputRef = (input) => {
    editInput = input;
  };

  const saveInputRef = (input) => {
    newInput = input;
  };

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    tagsInputConfirm(newTags);
  };

  return (
    <>
      {tags.length > 0 &&
        tags.map((tag, index) => {
          if (state.editInputIndex === index) {
            return (
              <Input
                ref={saveEditInputRef}
                key={tag}
                size="small"
                className="tag-input"
                value={state.editInputValue}
                onChange={handleEditInputChange}
                onBlur={handleEditInputConfirm}
                onPressEnter={handleEditInputConfirm}
              />
            );
          }

          const isLongTag = tag.length > 20;

          const tagElem = (
            <Tag className="edit-tag" key={tag} closable={true} onClose={() => handleClose(tag)}>
              <span
                onDoubleClick={(e) => {
                  setState((prevState) => ({ ...prevState, editInputIndex: index, editInputValue: tag }));
                  e.preventDefault();
                }}
              >
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </span>
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
      {state.inputVisible && (
        <Input
          ref={saveInputRef}
          type="text"
          size="small"
          className="tag-input"
          value={state.inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      )}
      {!state.inputVisible && (
        <Tag className="site-tag-plus" onClick={showInput}>
          <PlusOutlined /> {title}
        </Tag>
      )}
      {state.invalidFieldError.showError && state.invalidFieldError.messageError && (
        <div className="invalid-field-error">{state.invalidFieldError.messageError}</div>
      )}
    </>
  );
};
EditableTagGroup.propTypes = {
  tags: PropTypes.array,
  tagsInputConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  validation: PropTypes.func,
};

export default EditableTagGroup;
